import React, { Component } from "react";
import classnames from "classnames";

import { Button } from "../Button";
import * as styles from "./TabButton.scss";

export interface ITabButtonProps {
    index: number;
    activeIndex: number;
    onClicked: (index: number) => void;
}

export class TabButton extends Component<ITabButtonProps> {
    public render() {
        const { index, activeIndex } = this.props;
        return (
            <Button
                onClicked={this.onClicked}
                className={classnames(
                    styles["tab-button"],
                    index === activeIndex && styles.active,
                )}
            />
        );
    }

    private onClicked = () => {
        const { index, onClicked } = this.props;
        onClicked(index);
    };
}
